import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { OwnerDataCups } from "../../../../core/models/ownerData/ownerData.model";
import ConsumptionsManagementsDeliveryAddressComponent from "../../../ConsumptionsManagementsDeliveryAddressComponent/ConsumptionsManagementsDeliveryAddressComponent";
import ButtonElement from "../../../UI/ButtonElement/ButtonElement";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface ManagementsUpdateGasFlowCupsSelectionProps {
  ownerDataCups: OwnerDataCups[];
  ownerDataCupSelected: OwnerDataCups;
  setOwnerDataCupSelected: React.Dispatch<React.SetStateAction<OwnerDataCups>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const ManagementsUpdateGasFlowCupsSelection = ({
  ownerDataCups,
  ownerDataCupSelected,
  setOwnerDataCupSelected,
  setStep,
}: ManagementsUpdateGasFlowCupsSelectionProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Box component="div" paddingBottom={{ xs: "1.25rem", md: "2.5rem" }}>
        <Typography
          component="h3"
          variant="h3"
          paddingBottom={{ xs: "1.25rem", md: "2rem" }}
        >
          {t("Gestiones.Seleccione el CUPS")}
        </Typography>
        <Typography
          component="p"
          variant="body1"
          paddingBottom={{ xs: "0.75rem", md: "1.5rem" }}
        >
          {t(
            "Gestiones.Los cambios disponibles estarán sujetos a la tarifa contratada de gas"
          )}
        </Typography>
        <Typography component="p" variant="body1" sx={{fontWeight: 700, fontStyle: 'italic'}}>
          {t(
            "Gestiones.Solo realizamos cambio de potencia para servicios de gas"
          )}
        </Typography>
      </Box>
      <Stack
        width={{ xs: "100%", md: "25rem" }}
        paddingBottom={{ xs: "1.25rem", md: "2.5rem" }}
      >
        <ConsumptionsManagementsDeliveryAddressComponent
          ownerDataCups={ownerDataCups}
          ownerDataCupSelected={ownerDataCupSelected}
          setOwnerDataCupSelected={(ownerDataCupSelected: OwnerDataCups) =>
            setOwnerDataCupSelected(ownerDataCupSelected)
          }
          excludeElectricity={true}
        />
      </Stack>
      <Box
        component="div"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className="management-update-new-contact__actions"
        sx={{ flexDirection: { xs: "column", md: "row" } }}
      >
        <ButtonElement
          disabled={!!!ownerDataCupSelected.codeCups.length}
          onClick={() => setStep(0)}
        >
          {t("Gestiones.Seleccionar CUPS")}
        </ButtonElement>
        <ButtonElement
          onClick={() => {
            navigate(process.env.REACT_APP_MANAGEMENT!);
          }}
          secondary
        >
          {t("Cancelar")}
        </ButtonElement>
      </Box>
    </>
  );
};

export default ManagementsUpdateGasFlowCupsSelection;
